class Popup{
	constructor(name){
		this.name = name;
	}

	open(){
		this.showoverlay();
		this.eventsCloseForm();

		// show popup
		document.querySelector(this.name).classList.add('show');
	}

	close(){
		if (document.querySelectorAll('.transparent-overlay').length > 0)  document.querySelector('.transparent-overlay').remove();
		if (document.querySelectorAll('.thank').length > 0) document.querySelector('.thank').remove();
		// hide popup
		document.querySelector(this.name).classList.remove('show');
	}

	showoverlay(){
		const newOverlay = document.createElement('div');
		newOverlay.className ='transparent-overlay';
		document.querySelector('body').appendChild(newOverlay);
	}

	eventsCloseForm(){
		document.querySelector('.modal').addEventListener('click', function(e){
			if (e.target.className === 'modal show') wincalcPopup.close();
		});

		document.querySelector('.modal-close').addEventListener('click', function(){
			wincalcPopup.close();
		})

		document.onkeydown = (evt) => {
			evt = evt || window.event;
			let isEscape = false;
			if ("key" in evt) {
				isEscape = (evt.key === "Escape" || evt.key === "Esc");
			} else {
				isEscape = (evt.keyCode === 27);
			}
			if (isEscape && document.querySelector(this.name).classList.contains('show') > 0) {
				wincalcPopup.close();
			}
		};
	}
}

let wincalcPopup = new Popup('#wincalc-modal');

export default wincalcPopup;